import React, { useEffect, useMemo, useState, useRef, useCallback } from "react";
import "bulma/css/bulma.css";
import "../../../../../../../index.css";
import { useLocation, useNavigate } from "react-router-dom";
import { APIMS } from "../../../../../../../config/apims";
import { APILA } from "../../../../../../../config/apila";
import swal from "sweetalert";

/* ===========================
   🔥 CSS
=========================== */
const css = `
  @keyframes kaShimmer {
    0% { background-position: -700px 0; }
    100% { background-position: 700px 0; }
  }

  @keyframes kaSpin {
    to { transform: rotate(360deg); }
  }

  .ka-page {
    width: 100%;
    padding: 4px 0 28px;
  }

  .ka-hidden-reader {
    position: fixed;
    left: -9999px;
    top: -9999px;
    width: 1px;
    height: 1px;
    opacity: 0;
    pointer-events: none;
  }

  .ka-filter-card,
  .ka-table-card {
    width: 100%;
    background: #ffffff;
    border: 1px solid #e6ebf4;
    border-radius: 14px;
    box-shadow: 0 4px 18px rgba(39, 71, 140, 0.06);
  }

  .ka-filter-card {
    padding: 18px;
    margin-bottom: 18px;
  }

  .ka-filter-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 16px;
  }

  .ka-filter-title-wrap {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
  }

  .ka-filter-icon {
    width: 36px;
    height: 36px;
    flex: 0 0 36px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #315fba;
    background: #edf4ff;
    border-radius: 10px;
  }

  .ka-filter-title {
    margin: 0;
    color: #1f2a44;
    font-size: 15px;
    font-weight: 700;
    line-height: 1.3;
  }

  .ka-filter-subtitle {
    margin: 2px 0 0;
    color: #8a96aa;
    font-size: 12px;
    line-height: 1.35;
  }

  .ka-filter-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 14px 12px;
    align-items: end;
  }

  .ka-field {
    min-width: 0;
  }

  .ka-label {
    display: block;
    margin-bottom: 7px;
    color: #4c5870;
    font-size: 12px;
    font-weight: 700;
  }

  .ka-select-wrap {
    position: relative;
  }

  .ka-select-wrap::after {
    content: "";
    position: absolute;
    right: 13px;
    top: 50%;
    width: 7px;
    height: 7px;
    border-right: 1.7px solid #72809a;
    border-bottom: 1.7px solid #72809a;
    transform: translateY(-68%) rotate(45deg);
    pointer-events: none;
  }

  .ka-select {
    width: 100%;
    height: 42px;
    padding: 0 36px 0 12px;
    border: 1px solid #dce3ef;
    border-radius: 9px;
    outline: none;
    appearance: none;
    -webkit-appearance: none;
    background: #ffffff;
    color: #2f3a50;
    font-size: 13px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  }

  .ka-select:hover:not(:disabled) {
    border-color: #b9c9e7;
  }

  .ka-select:focus {
    border-color: #4c78d3;
    box-shadow: 0 0 0 3px rgba(76, 120, 211, 0.12);
  }

  .ka-select:disabled {
    color: #9aa5b6;
    background: #f6f8fb;
    cursor: not-allowed;
  }

  .ka-filter-button-field {
    display: flex;
    align-items: flex-end;
    min-width: 0;
  }

  .ka-filter-button-field .ka-btn-filter,
  .ka-filter-button-field .ka-shimmer-button {
    width: 100%;
  }

  .ka-btn {
    min-height: 40px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 9px 16px;
    border: 1px solid transparent;
    border-radius: 9px;
    font-size: 13px;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.2s ease, background 0.2s ease, border-color 0.2s ease;
  }

  .ka-btn:hover:not(:disabled) {
    transform: translateY(-1px);
  }

  .ka-btn:disabled {
    opacity: 0.58;
    cursor: not-allowed;
    transform: none;
  }

  .ka-btn-filter {
    min-width: 116px;
    color: #ffffff;
    background: #e9a51a;
    border-color: #e9a51a;
    box-shadow: 0 4px 10px rgba(233, 165, 26, 0.2);
  }

  .ka-btn-filter:hover:not(:disabled) {
    background: #d89512;
    border-color: #d89512;
  }

  .ka-btn-primary {
    color: #ffffff;
    background: #3768c5;
    border-color: #3768c5;
    box-shadow: 0 4px 12px rgba(55, 104, 197, 0.18);
  }

  .ka-btn-primary:hover:not(:disabled) {
    background: #2e59aa;
    border-color: #2e59aa;
  }

  .ka-btn-action {
    min-height: 34px;
    padding: 7px 12px;
    color: #315fba;
    background: #edf4ff;
    border-color: #d7e5ff;
    border-radius: 8px;
    font-size: 12px;
    box-shadow: none;
  }

  .ka-btn-action:hover:not(:disabled) {
    color: #ffffff;
    background: #3768c5;
    border-color: #3768c5;
  }

  .ka-btn-spinner {
    width: 14px;
    height: 14px;
    border: 2px solid rgba(255, 255, 255, 0.45);
    border-top-color: #ffffff;
    border-radius: 50%;
    animation: kaSpin 0.7s linear infinite;
  }

  .ka-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    margin: 18px 0 12px;
  }

  .ka-search-wrap {
    position: relative;
    width: min(100%, 360px);
  }

  .ka-search-icon {
    position: absolute;
    left: 13px;
    top: 50%;
    transform: translateY(-50%);
    color: #8c98ab;
    pointer-events: none;
  }

  .ka-search-input {
    width: 100%;
    height: 42px;
    padding: 0 14px 0 40px;
    border: 1px solid #dce3ef;
    border-radius: 10px;
    outline: none;
    background: #ffffff;
    color: #27334a;
    font-size: 13px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
  }

  .ka-search-input::placeholder {
    color: #a1aaba;
  }

  .ka-search-input:focus {
    border-color: #4c78d3;
    box-shadow: 0 0 0 3px rgba(76, 120, 211, 0.11);
  }

  .ka-toolbar-right {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
  }

  .ka-total-badge {
    display: inline-flex;
    align-items: center;
    min-height: 34px;
    padding: 7px 11px;
    border: 1px solid #e1e7f1;
    border-radius: 8px;
    background: #f8faff;
    color: #64718a;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
  }

  .ka-reader-note {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 12px;
    padding: 11px 13px;
    border: 1px solid #dce8ff;
    border-radius: 10px;
    background: #f4f8ff;
    color: #52617c;
    font-size: 12px;
    line-height: 1.5;
  }

  .ka-reader-dot {
    width: 9px;
    height: 9px;
    flex: 0 0 9px;
    margin-top: 4px;
    border: 2px solid #ffffff;
    border-radius: 50%;
    background: #3f72d0;
    box-shadow: 0 0 0 2px #bfd3fb;
  }

  .ka-table-card {
    overflow: hidden;
  }

  .ka-table-scroll {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .ka-table {
    width: 100%;
    min-width: 720px;
    margin: 0;
    border-collapse: separate;
    border-spacing: 0;
    table-layout: fixed;
  }

  .ka-table thead th {
    padding: 13px 15px;
    border: 0;
    border-bottom: 1px solid #dfe7f4;
    background: #edf4ff;
    color: #315fba;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.01em;
    text-align: left;
    vertical-align: middle;
    white-space: nowrap;
  }

  .ka-table tbody td {
    padding: 12px 15px;
    border: 0;
    border-bottom: 1px solid #edf0f5;
    background: #ffffff;
    color: #344057;
    font-size: 13px;
    vertical-align: middle;
    transition: background 0.18s ease;
  }

  .ka-table tbody tr:last-child td {
    border-bottom: 0;
  }

  .ka-table tbody tr:hover td {
    background: #fafcff;
  }

  .ka-table tbody tr.ka-active-row td {
    background: #eef5ff;
  }

  .ka-table tbody tr.ka-active-row td:first-child {
    box-shadow: inset 3px 0 0 #3768c5;
  }

  .ka-col-no {
    width: 76px;
    text-align: center !important;
  }

  .ka-number-badge {
    width: 29px;
    height: 29px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #d7e4fb;
    border-radius: 50%;
    background: #edf4ff;
    color: #3768c5;
    font-size: 12px;
    font-weight: 800;
    line-height: 1;
  }

  .ka-table tbody tr.ka-active-row .ka-number-badge {
    border-color: #3768c5;
    background: #3768c5;
    color: #ffffff;
    box-shadow: 0 3px 8px rgba(55, 104, 197, 0.22);
  }

  .ka-col-name {
    width: auto;
  }

  .ka-col-code {
    width: 240px;
    text-align: center !important;
  }

  .ka-col-action {
    width: 130px;
    text-align: center !important;
  }

  .ka-student-name {
    display: block;
    color: #263249;
    font-weight: 600;
    line-height: 1.45;
    word-break: break-word;
  }

  .ka-code-wrap {
    position: relative;
    width: 100%;
    max-width: 190px;
    margin: 0 auto;
  }

  .ka-code-input {
    width: 100%;
    height: 36px;
    padding: 0 10px;
    border: 1px solid #d7dfeb;
    border-radius: 8px;
    outline: none;
    background: #ffffff;
    color: #263249;
    font-size: 13px;
    font-weight: 600;
    text-align: center;
    letter-spacing: 0.02em;
    transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
  }

  .ka-code-input:hover:not(:disabled) {
    border-color: #b6c6e2;
  }

  .ka-code-input:focus,
  .ka-code-input.is-active {
    border-color: #3768c5;
    box-shadow: 0 0 0 3px rgba(55, 104, 197, 0.12);
  }

  .ka-code-input:disabled {
    background: #f7f9fc;
    color: #8590a3;
  }

  .ka-saving-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    border-radius: 8px;
    background: rgba(247, 249, 252, 0.94);
    color: #657188;
    font-size: 11px;
    font-weight: 700;
    pointer-events: none;
  }

  .ka-saving-dot {
    width: 12px;
    height: 12px;
    border: 2px solid #c5cfde;
    border-top-color: #3768c5;
    border-radius: 50%;
    animation: kaSpin 0.7s linear infinite;
  }

  .ka-empty {
    padding: 46px 16px !important;
    text-align: center;
  }

  .ka-empty-icon {
    width: 44px;
    height: 44px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    border-radius: 12px;
    background: #f0f4fb;
    color: #8b98ac;
  }

  .ka-empty-title {
    margin: 0;
    color: #4b5870;
    font-size: 13px;
    font-weight: 700;
  }

  .ka-empty-text {
    margin: 4px 0 0;
    color: #98a2b2;
    font-size: 12px;
  }

  .ka-shimmer {
    position: relative;
    overflow: hidden;
    background: linear-gradient(90deg, #e9eff8 8%, #f7f9fd 18%, #e9eff8 33%);
    background-size: 1100px 100%;
    animation: kaShimmer 1.25s linear infinite;
  }

  .ka-shimmer-label {
    width: 72px;
    height: 10px;
    margin-bottom: 8px;
    border-radius: 5px;
  }

  .ka-shimmer-control {
    width: 100%;
    height: 42px;
    border-radius: 9px;
  }

  .ka-shimmer-button {
    width: 100%;
    height: 40px;
    border-radius: 9px;
  }

  .ka-loading-card {
    overflow: hidden;
    border: 1px solid #e6ebf4;
    border-radius: 14px;
    background: #ffffff;
  }

  .ka-loading-head {
    height: 46px;
    border-bottom: 1px solid #e5ebf4;
    background: #edf4ff;
  }

  .ka-loading-row {
    display: grid;
    grid-template-columns: 70px 1fr 220px 120px;
    gap: 14px;
    align-items: center;
    min-width: 720px;
    padding: 12px 15px;
    border-bottom: 1px solid #edf0f5;
  }

  .ka-loading-row:last-child {
    border-bottom: 0;
  }

  .ka-loading-line {
    height: 12px;
    border-radius: 6px;
  }

  .ka-loading-line.short { width: 38px; }
  .ka-loading-line.medium { width: 65%; }
  .ka-loading-line.code { width: 150px; justify-self: center; }
  .ka-loading-line.action { width: 72px; justify-self: center; }

  @media (max-width: 900px) and (min-width: 781px) {
    .ka-filter-grid {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }

  @media (max-width: 780px) {
    .ka-page {
      padding-top: 0;
    }

    .ka-filter-card {
      padding: 15px;
      border-radius: 12px;
    }

    .ka-filter-header {
      align-items: flex-start;
      margin-bottom: 14px;
    }

    .ka-filter-grid {
      grid-template-columns: 1fr;
      gap: 11px;
    }

    .ka-filter-button-field,
    .ka-filter-button-field .ka-btn-filter {
      width: 100%;
    }

    .ka-toolbar {
      align-items: stretch;
      flex-direction: column;
      gap: 10px;
      margin-top: 16px;
    }

    .ka-search-wrap {
      width: 100%;
    }

    .ka-toolbar-right {
      width: 100%;
      justify-content: space-between;
    }

    .ka-toolbar-right .ka-btn-primary {
      flex: 1;
    }

    .ka-reader-note {
      font-size: 11.5px;
    }

    .ka-table-card,
    .ka-loading-card {
      border-radius: 12px;
    }
  }

  @media (max-width: 430px) {
    .ka-filter-title {
      font-size: 14px;
    }

    .ka-filter-subtitle {
      font-size: 11px;
    }

    .ka-toolbar-right {
      align-items: stretch;
      flex-direction: column;
    }

    .ka-total-badge {
      justify-content: center;
    }
  }
`;

const FilterIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M4 6h16M7 12h10M10 18h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const SearchIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <circle cx="11" cy="11" r="7" stroke="currentColor" strokeWidth="2" />
    <path d="m20 20-3.5-3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

const PrintIcon = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M7 8V4h10v4M7 17H5a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7 14h10v6H7z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    <path d="M17 12h.01" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
  </svg>
);

const EmptyIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M8 7V3m8 4V3M5 11h14M6 5h12a2 2 0 0 1 2 2v12H4V7a2 2 0 0 1 2-2Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9 15h6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);
export default function KonfigurasiPasscode() {
  document.title = "Konfigurasi Passcode";
    const [page] = useState(1);
    const [limit] = useState(1000);
    const [ascending] = useState(1);
    const token = localStorage.getItem("token");
    
    const [loadingBranch, setLoadingBranch] = useState(true);
    const [loadingSemester, setLoadingSemester] = useState(true);
    const [loadingSchool, setLoadingSchool] = useState(false);

    const firstLoadDone = useRef(false);
    const initSchoolDone = useRef(false);
    const initLevelDone = useRef(false);
    const initKelasDone = useRef(false);

    const storageLevel = localStorage.getItem("level");

    
    // Data master
    const [getDataSemesterMap, setGetDataSemesterMap] = useState([]);
    const [getDataBranch, setGetDataBranch] = useState([]);
    const [getDataSchool, setGetDataSchool] = useState([]);
    
    // Tingkatan & Kelas
    const [getDataLevel, setGetDataLevel] = useState([]);
    const [getDataKelas, setGetDataKelas] = useState([]);
    const [loadingLevel, setLoadingLevel] = useState(false);
    const [loadingKelas, setLoadingKelas] = useState(false);
    
    
    // Table data
    const [getData, setGetData] = useState([]);

    // Input kode absen per siswa
    const [kodeAbsenMap, setKodeAbsenMap] = useState({});
    const [savingRows, setSavingRows] = useState({});
    const [activeRowIndex, setActiveRowIndex] = useState(0);

    

    // Untuk metode tap kartu
    // const tapInputRef = useRef(null);
    // const rowInputRefs = useRef({});
    // const tapBufferRef = useRef("");
    // const tapTimerRef = useRef(null);

    const tapInputRef = useRef(null);
    const rowInputRefs = useRef({});
    const rowTrRefs = useRef({});
    const tapBufferRef = useRef("");
    const tapTimerRef = useRef(null);
    const activeRowIndexRef = useRef(0);

    useEffect(() => {
      activeRowIndexRef.current = activeRowIndex;
    }, [activeRowIndex]);

    const manualEditingRef = useRef(false);

    // Search
    const [searchKeyword, setSearchKeyword] = useState("");

    // UI state
    const [hasSearched, setHasSearched] = useState(false);
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [isFilterDirty, setIsFilterDirty] = useState(false);
    const [isFetching, setIsFetching] = useState(false);

    const [namaTA, setNamaTA] = useState("");
    const [namaSmstr, setNamaSmstr] = useState("");


    // Filter form
    const [form2, setForm2] = useState({
      ysb_semester_id: "",
      ysb_branch_id: "",
      ysb_school_id: "",
      ysb_grade_level_id:"",
      ysb_kelas_id:"",
    });

    // Permission
    const location = useLocation();
    const [permission, setPermission] = useState({
      create: 0,
      read: 0,
      update: 0,
      delete: 0,
    });

    const navigate = useNavigate();
    
    useEffect(() => {
      const level = localStorage.getItem("level");
      const storageItems = JSON.parse(localStorage.getItem("role_permission")) || [];
      if (level === "developer" || level === "superadmin") {
        setPermission({ create: 1, read: 1, update: 1, delete: 1 });
        return;
      }
      const foundPermission = storageItems.find((item) => item.menu?.url === location.pathname);
      if (!foundPermission) navigate("/dashboard");
      else {
        setPermission({
        create: foundPermission.create,
        read: foundPermission.read,
        update: foundPermission.update,
        delete: foundPermission.delete,
        });
      }
    }, [location.pathname, navigate]);
    
    /* API HEADERS */
    const fetchParams = useMemo(
      () => ({
        headers: {
          Authorization: `${token}`,
          "Content-Type": "application/json",
        },
      }), [token]
    );
    
    // ---------- helper refs ----------
    const isMounted = useRef(true);
    const abortControllers = useRef([]);
    
    useEffect(() => {
      return () => {
        isMounted.current = false;
        abortControllers.current.forEach((c) => c.abort());
      };
    }, []);
    
    const collator = useMemo(() => new Intl.Collator("id", { numeric: true, sensitivity: "base" }), []);
      
    const safeStr = (v) => (v === null || v === undefined ? "" : String(v));
    
    // SORT sekolah
    const sortSchools = (schools) => {
      const order = ["SD", "SMP", "SMA"];
      return [...schools].sort((a, b) => {
        const jenjangA = order.findIndex((j) => (a.school_name || "").toUpperCase().includes(j));
        const jenjangB = order.findIndex((j) => (b.school_name || "").toUpperCase().includes(j));
        return jenjangA - jenjangB;
      });
    };

    const removeBasementBekasi = (schools, branchId) => {
      if (branchId === "BKS") return schools.filter((s) => s.school_code !== "BASEMENT_BEKASI");
      return schools;
    };


    const fetchCabang = async () => {
      setLoadingBranch(true);

      try {
        const response = await APIMS.get(
          `/api/access/branches?page=1&limit=1000&ascending=${ascending}&search=`,
          fetchParams
        );

        if (response?.status === 200) {
          const branches = response.data.data || [];
          setGetDataBranch(branches);

          if (branches.length > 0) {
            const firstBranch = branches[0].branch_code;
            setForm2((prev) => ({ ...prev, ysb_branch_id: firstBranch }));
          }
        }
      } catch (error) {
        console.error("Gagal mengambil data cabang:", error);
      } finally {
        setLoadingBranch(false);
      }
    };

    useEffect(() => {
        fetchCabang();
    }, [])

    const fetchSemester = async () => {
      setLoadingSemester(true);

      try {
        const response = await APIMS.get(
          `/api/access/semesters?page=1&limit=1000&ascending=${ascending}&search=`,
          fetchParams
        );

        if (response?.status === 200) {
          const semesters = response.data.data || [];
          const active = semesters.find((item) => item.status === 1) || semesters[0];
          setGetDataSemesterMap(semesters);

          if (active) {
            setNamaTA(active.name_year || "");
            setNamaSmstr(active.semester || "");
            setForm2((prev) => ({ ...prev, ysb_semester_id: active.id }));
          }
        }
      } catch (error) {
        console.error("Gagal mengambil data semester:", error);
      } finally {
        setLoadingSemester(false);
      }
    };

    useEffect(() => {
        fetchSemester();
    }, [])

    const fetchSchoolsByBranch = useCallback(
      async (branchId) => {
        initSchoolDone.current = false;
        initLevelDone.current = false;
        initKelasDone.current = false;
        setLoadingSchool(true); 
        try {
          const res = await APIMS.get(
            `/api/access/schools?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
            fetchParams
          );
          if (res?.status === 200) {
            let schools = res.data.data || [];

            if (storageLevel === "developer" || storageLevel === "superadmin") {
              schools = schools.filter(
                (s) => s.ysb_branch_id === branchId
              );
            }

            schools = removeBasementBekasi(schools, branchId);
            schools = sortSchools(schools);

            setGetDataSchool(schools);

            // default sekolah pertama
            if (schools.length > 0) {
              // reset dependensi saat sekolah berubah (tingkatan/kelas)
              setGetDataLevel([]);
              setGetDataKelas([]);
              setForm2((prev) => ({
                ...prev,
                ysb_school_id: schools[0].school_code,
                ysb_grade_level_id: "",
                ysb_kelas_id: "",
              }));
            } else {
              setGetDataLevel([]);
              setGetDataKelas([]);
              setForm2((prev) => ({ ...prev, ysb_school_id: "", ysb_grade_level_id: "", ysb_kelas_id: "" }));
            }
          }
        } catch (err) {
          console.log(err);
        } finally {
            initSchoolDone.current = true;
            setLoadingSchool(false);
        }
      },[ascending, fetchParams, limit, page, storageLevel]
    );

    useEffect(() => {
      if (form2.ysb_branch_id) fetchSchoolsByBranch(form2.ysb_branch_id);
    }, [form2.ysb_branch_id, fetchSchoolsByBranch]);


    // =========================
    // Fetch tingkatan saat sekolah berubah
    // =========================
    const sortLevels = (levels) => {
      return [...levels].sort((a, b) =>
        (a?.name_level || "").localeCompare((b?.name_level || ""), "id", { numeric: true, sensitivity: "base" })
      );
    };

    const sortKelas = (kelas) => {
      return [...kelas].sort((a, b) =>
        (a?.name_kelas || "").localeCompare((b?.name_kelas || ""), "id", { numeric: true, sensitivity: "base" })
      );
    };

    const fetchLevelsBySchool = useCallback(
      async (schoolId, branchId) => {
        initLevelDone.current = false;
        initKelasDone.current = false; 
        if (!schoolId) return;

        setLoadingLevel(true);
        try {
          const res = await APIMS.get(
            `/api/grade-levels?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
            fetchParams
          );

          if (res?.status === 200) {
            let levels = res.data?.data || [];

           
            levels = levels.filter((x) => x?.ysb_school_id === schoolId);
            if (branchId) levels = levels.filter((x) => x?.ysb_branch_id === branchId);

            levels = sortLevels(levels);
            setGetDataLevel(levels);

            if (levels.length === 0) {
              initKelasDone.current = true;
            }

            // default tingkatan pertama
            if (levels.length > 0) {
              setForm2((prev) => ({
                ...prev,
                ysb_grade_level_id: levels[0].id,
              }));
            } else {
              setForm2((prev) => ({
                ...prev,
                ysb_grade_level_id: "",
                ysb_kelas_id: "",
              }));

            setGetDataKelas([]);
            }
          }
        } catch (err) {
          console.error(err);
          swal({
            title: "Failed",
            text: err?.response?.data?.message || err.message || "Gagal mengambil data tingkatan",
            icon: "error",
            timer: 3000,
            buttons: false,
          });

          setGetDataLevel([]);
          setGetDataKelas([]);
          setForm2((prev) => ({ ...prev, ysb_grade_level_id: "", ysb_kelas_id: "" }));

        } finally {
          initLevelDone.current = true;
          setLoadingLevel(false);
        }
      }, [fetchParams]
    );

   
    useEffect(() => {
      if (!form2.ysb_school_id) {
        setGetDataLevel([]);
        setGetDataKelas([]);
        setForm2((prev) => ({ ...prev, ysb_grade_level_id: "", ysb_kelas_id: "" }));
      return;
      }

      setGetDataLevel([]);
      setGetDataKelas([]);
      setForm2((prev) => ({ ...prev, ysb_grade_level_id: "", ysb_kelas_id: "" }));
      fetchLevelsBySchool(form2.ysb_school_id, form2.ysb_branch_id);
    }, [form2.ysb_school_id, form2.ysb_branch_id, fetchLevelsBySchool]);

    // =========================
    // Fetch kelas saat tingkatan berubah
    // =========================
    const fetchKelasByLevel = useCallback(
      async (gradeLevelId, schoolId, branchId) => {
        initKelasDone.current = false;

        if (!gradeLevelId) return;

        setLoadingKelas(true);
        try {
          const res = await APIMS.get(
            `/api/kelas?page=${page}&limit=${limit}&ascending=${ascending}&branch=${branchId}&level=${storageLevel}`,
            fetchParams
          );

          if (res?.status === 200) {
            let kelas = res.data?.data || [];

            kelas = kelas.filter((x) => x?.ysb_grade_level_id === gradeLevelId);
            if (schoolId) kelas = kelas.filter((x) => x?.ysb_school_id === schoolId);
            if (branchId) kelas = kelas.filter((x) => x?.ysb_branch_id === branchId);

            kelas = sortKelas(kelas);
            setGetDataKelas(kelas);

            // default kelas pertama
            if (kelas.length > 0) {
              setForm2((prev) => ({
                ...prev,
                ysb_kelas_id: kelas[0].id,
              }));
            } else {
              setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
            }
          }
        } catch (err) {
          console.error(err);
          swal({
            title: "Failed",
            text: err?.response?.data?.message || err.message || "Gagal mengambil data kelas",
            icon: "error",
            timer: 3000,
            buttons: false,
          });
          setGetDataKelas([]);
          setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
        } finally {
          initKelasDone.current = true;
          setLoadingKelas(false);
        }
      }, [fetchParams]
    );

    useEffect(() => {
      if (!form2.ysb_grade_level_id) {
        setGetDataKelas([]);
        setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
        return;
      }

      setGetDataKelas([]);
      setForm2((prev) => ({ ...prev, ysb_kelas_id: "" }));
      fetchKelasByLevel(form2.ysb_grade_level_id, form2.ysb_school_id, form2.ysb_branch_id);
    }, [form2.ysb_grade_level_id, form2.ysb_school_id, form2.ysb_branch_id, fetchKelasByLevel]);

  
    // =========================
    // Filter complete
    // =========================
    const isFilterComplete =
      isFilterDirty &&
      !!form2.ysb_semester_id &&
      !!form2.ysb_branch_id &&
      !!form2.ysb_school_id &&
      (!loadingLevel && (getDataLevel.length === 0 || !!form2.ysb_grade_level_id)) &&
      (!loadingKelas && (getDataKelas.length === 0 || !!form2.ysb_kelas_id));

    // =========================
    // Fetch table data
    // =========================
    const GetResponseData = useCallback(async () => {
      if (
        !form2.ysb_semester_id ||
        !form2.ysb_branch_id ||
        !form2.ysb_school_id
      ) return;

      setIsFetching(true);

      const payload = {
        ysb_semester_id: form2.ysb_semester_id,
        ysb_branch_id: form2.ysb_branch_id,
        ysb_school_id: form2.ysb_school_id,
      };

      if (form2.ysb_grade_level_id) {
        payload.ysb_grade_level_id = form2.ysb_grade_level_id;
      }

      if (form2.ysb_kelas_id) {
        payload.ysb_kelas_id = form2.ysb_kelas_id;
      }

      try {
        const response = await APILA.post(
          "/api/card-absen/check",
          payload,
          fetchParams
        );

        if (response?.status === 200) {
          const students = response.data?.data_students || [];

          setGetData(students);

          const initialKodeMap = {};
          students.forEach((item) => {
            const studentId = item?.ysb_student_id || item?.id;
            initialKodeMap[studentId] = item?.kode_absen || "";
          });

          setKodeAbsenMap(initialKodeMap);
          setActiveRowIndex(0);

          setTimeout(() => {
            tapInputRef.current?.focus();
          }, 300);
        }
      } catch (error) {
        swal({
          title: "Gagal",
          text: error?.response?.data?.message || "Gagal mengambil data kartu absen",
          icon: "error",
        });
      } finally {
        setIsFetching(false);
      }
    }, [form2, fetchParams]);


    // AUTO LOAD
    useEffect(() => {
      const schoolReady =
        initSchoolDone.current &&
        !loadingSchool &&
        !!form2.ysb_school_id;

      const gradeReady =
        initLevelDone.current &&
        !loadingLevel &&
        (getDataLevel.length === 0 || !!form2.ysb_grade_level_id);

      const kelasReady =
        initKelasDone.current &&
        !loadingKelas &&
        (getDataKelas.length === 0 || !!form2.ysb_kelas_id);

      if (
        firstLoadDone.current ||
        !form2.ysb_semester_id ||
        !form2.ysb_branch_id ||
        !schoolReady ||
        !gradeReady ||
        !kelasReady
      ) return;

      firstLoadDone.current = true;

      (async () => {
        setIsFetching(true);
        await GetResponseData(); 
        setHasSearched(true);
        setIsFirstLoad(false);
        setIsFilterDirty(false);
        setIsFetching(false);
      })();
    }, [
      form2.ysb_semester_id,
      form2.ysb_branch_id,
      form2.ysb_school_id,
      form2.ysb_grade_level_id,
      form2.ysb_kelas_id,
      loadingSchool,
      loadingLevel,
      loadingKelas,
      getDataLevel.length,
      getDataKelas.length,
    ]);


    // =========================
    // HANDLER perubahan filter 
    // =========================
    const handleChange = (e) => {
      const { name, value } = e.target;

      setForm2((prev) => ({ ...prev, [name]: value }));

      if (!isFirstLoad) {
        setIsFilterDirty(true);
        setHasSearched(false);
      }
    };

    // =========================
    // BUTTON CARI
    // =========================
    const handleCari = async () => {
      
      if (loadingSchool || loadingLevel || loadingKelas) {
        swal({
          title: "Mohon tunggu",
          text: "Data sekolah/tingkatan/kelas masih dimuat. Coba lagi sebentar.",
          icon: "info",
          timer: 2200,
          buttons: false,
        });
        return;
      }

      const gradeRequired = getDataLevel.length === 0 ? true : !!form2.ysb_grade_level_id;
      const kelasRequired = getDataKelas.length === 0 ? true : !!form2.ysb_kelas_id;

      if (!form2.ysb_semester_id || !form2.ysb_branch_id || !form2.ysb_school_id || !gradeRequired || !kelasRequired) {
        swal({
          title: "Filter belum lengkap",
          text: "Pastikan Semester, Cabang, Sekolah, Tingkatan,dan Kelas sudah dipilih.",
          icon: "warning",
        });
        return;
      }

      setGetData([]);
      setHasSearched(false);
      setIsFetching(true);
      setSearchKeyword("");

      try {
        await GetResponseData();
        setHasSearched(true);
        setIsFilterDirty(false);
      } catch (err) {
        swal({
          title: "Failed",
          text: err?.response?.data?.message || "Terjadi kesalahan",
          icon: "error",
        });
      } finally {
        setIsFetching(false);
      }
    };

    // =========================
    // Filter + Search + Sorting
    // =========================
    const displayedData = useMemo(() => {
      let rows = Array.isArray(getData) ? [...getData] : [];
     
      // Search (Nama siswa / NISN)
      const q = safeStr(searchKeyword).trim().toLowerCase();
      if (q) {
        rows = rows.filter((r) => {
          const siswa = safeStr(r?.nama_lengkap).toLowerCase();
          const nisn = safeStr(
            r?.nisn ||
            r?.student_nisn ||
            r?.ysb_student_nisn ||
            r?.nomor_nisn ||
            r?.nisn_siswa
          ).toLowerCase();

          return siswa.includes(q) || nisn.includes(q);
        });
      }
      // Sort nama siswa A -> Z
      rows.sort((a, b) => collator.compare(safeStr(a?.nama_lengkap), safeStr(b?.nama_lengkap)));
  
      return rows;
    }, [collator, form2.ysb_grade_level_id, form2.ysb_kelas_id, getData, searchKeyword]);
  
    // =========================
    const toTitleCase = (value) => {
      const s = safeStr(value).toLowerCase().trim();
      if (!s) return "";
      return s.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.slice(1));
    };


    const focusTapReader = useCallback((delay = 0) => {
      setTimeout(() => {
        if (!manualEditingRef.current) {
          tapInputRef.current?.focus();
        }
      }, delay);
    }, []);

    const moveToNextTapRow = useCallback(
      (currentIndex) => {
        const nextIndex = currentIndex + 1;
        const nextRow = displayedData[nextIndex];

        if (!nextRow) {
          setActiveRowIndex(nextIndex);
          focusTapReader(80);
          return;
        }

        const nextStudentId = nextRow?.ysb_student_id || nextRow?.id;

        setActiveRowIndex(nextIndex);
        activeRowIndexRef.current = nextIndex;

        setTimeout(() => {
          if (nextStudentId && rowTrRefs.current[nextStudentId]) {
            rowTrRefs.current[nextStudentId].scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }

          // RFID tetap harus fokus ke input hidden agar tap berikutnya langsung masuk
          focusTapReader(0);
        }, 120);
      },
      [displayedData, focusTapReader]
    );


    const handleUpdateKodeAbsen = useCallback(
      async (studentId, kodeAbsen, rowIndex, options = {}) => {
        const cleanKode = safeStr(kodeAbsen).trim();

        if (!studentId) return;

        setSavingRows((prev) => ({
          ...prev,
          [studentId]: true,
        }));

        try {
          const response = await APILA.post(
            "/api/card-absen/update",
            {
              ysb_student_id: studentId,
              kode_absen: cleanKode,
            },
            fetchParams
          );

          if (response?.status === 200) {
            setKodeAbsenMap((prev) => ({
              ...prev,
              [studentId]: cleanKode,
            }));

            setGetData((prev) =>
              prev.map((item) => {
                const itemId = item?.ysb_student_id || item?.id;

                if (itemId === studentId) {
                  return {
                    ...item,
                    kode_absen: cleanKode,
                  };
                }

                return item;
              })
            );

            if (options.fromTap) {
              moveToNextTapRow(rowIndex);
            }
          }
        } catch (error) {
          swal({
            title: "Gagal",
            text: error?.response?.data?.message || "Gagal menyimpan kode absen",
            icon: "error",
          });

          if (options.fromTap) {
            focusTapReader(150);
          }
        } finally {
          setSavingRows((prev) => ({
            ...prev,
            [studentId]: false,
          }));

          // Jangan paksa focus ke hidden input untuk semua kondisi,
          // karena ini bisa meniban fokus manual.
          if (options.fromTap) {
            focusTapReader(150);
          }
        }
      },
      [fetchParams, moveToNextTapRow, focusTapReader]
    );


    const handleManualKodeChange = (studentId, value) => {
      const cleanValue = value.replace(/\D/g, "").slice(0, 20);

      setKodeAbsenMap((prev) => ({
        ...prev,
        [studentId]: cleanValue,
      }));
    };

    const handleManualKodeFocus = (rowIndex) => {
      manualEditingRef.current = true;
      setActiveRowIndex(rowIndex);
    };


    const handleManualKodeBlur = (studentId, rowIndex) => {
      manualEditingRef.current = false;

      const currentValue = safeStr(kodeAbsenMap[studentId]).trim();

      const oldValue = safeStr(
        getData.find((item) => (item?.ysb_student_id || item?.id) === studentId)
          ?.kode_absen
      ).trim();

      // kalau tidak berubah, tidak usah save
      if (currentValue === oldValue) {
        setTimeout(() => {
          tapInputRef.current?.focus();
        }, 150);
        return;
      }

      handleUpdateKodeAbsen(studentId, currentValue, rowIndex, {
        fromTap: false,
      });

      setTimeout(() => {
        tapInputRef.current?.focus();
      }, 300);
    };

    const handleManualKodeKeyDown = (e, studentId, rowIndex) => {
      if (e.key === "Enter") {
        e.preventDefault();

        handleUpdateKodeAbsen(studentId, kodeAbsenMap[studentId], rowIndex, {
          fromTap: false,
        });

        const nextIndex = rowIndex + 1;
        const nextRow = displayedData[nextIndex];
        const nextStudentId = nextRow?.ysb_student_id || nextRow?.id;

        if (nextStudentId && rowInputRefs.current[nextStudentId]) {
          rowInputRefs.current[nextStudentId].focus();
        }
      }
    };

    const handleTapInputChange = (e) => {
      const value = e.target.value;

      tapBufferRef.current = value;

      if (tapTimerRef.current) {
        clearTimeout(tapTimerRef.current);
      }

      tapTimerRef.current = setTimeout(() => {
        const kodeTap = safeStr(tapBufferRef.current).trim();

        if (!kodeTap) return;

        const currentIndex = activeRowIndexRef.current;
        const targetRow = displayedData[currentIndex];

        if (!targetRow) {
          swal({
            title: "Data siswa habis",
            text: "Semua baris siswa sudah terisi atau tidak ada baris selanjutnya.",
            icon: "info",
            timer: 2500,
            buttons: false,
          });

          tapBufferRef.current = "";

          if (tapInputRef.current) {
            tapInputRef.current.value = "";
          }

          focusTapReader(100);
          return;
        }

        const studentId = targetRow?.ysb_student_id || targetRow?.id;

        setKodeAbsenMap((prev) => ({
          ...prev,
          [studentId]: kodeTap,
        }));

        handleUpdateKodeAbsen(studentId, kodeTap, currentIndex, {
          fromTap: true,
        });

        tapBufferRef.current = "";

        if (tapInputRef.current) {
          tapInputRef.current.value = "";
        }

        focusTapReader(50);
      }, 120);
    };

    useEffect(() => {
      const focusTapInput = () => {
        if (manualEditingRef.current) return;

        setTimeout(() => {
          if (!manualEditingRef.current) {
            tapInputRef.current?.focus();
          }
        }, 100);
      };

      focusTapInput();

      window.addEventListener("click", focusTapInput);

      return () => {
        window.removeEventListener("click", focusTapInput);

        if (tapTimerRef.current) {
          clearTimeout(tapTimerRef.current);
        }
      };
    }, []);

    

    const escapeHtml = (value) => {
      return safeStr(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    };

    const getBarcodeRows = (rows = []) => {
      return rows
        .map((row, index) => {
          const studentId = row?.ysb_student_id || row?.id;
          const kodeAbsen = safeStr(kodeAbsenMap[studentId] || row?.kode_absen).trim();

          return {
            no: index + 1,
            studentId,
            nama: toTitleCase(row?.nama_lengkap),
            kodeAbsen,
          };
        })
        .filter((item) => item.kodeAbsen);
    };

    const handlePrintBarcode = (rows = [], title = "Cetak Barcode Absensi") => {
      const barcodeRows = getBarcodeRows(rows);

      if (barcodeRows.length === 0) {
        swal({
          title: "Tidak ada barcode",
          text: "Belum ada kode absensi yang bisa dicetak.",
          icon: "warning",
        });
        return;
      }

      const barcodeItemsHtml = barcodeRows
        .map(
          (item) => `
            <div class="barcode-card">
              <div class="student-name">${escapeHtml(item.nama || "-")}</div>
              <svg
                class="barcode-svg"
                data-code="${escapeHtml(item.kodeAbsen)}"
              ></svg>
              <div class="barcode-code">${escapeHtml(item.kodeAbsen)}</div>
            </div>
          `
        )
        .join("");

      const iframeId = "barcode-print-iframe";

      const oldIframe = document.getElementById(iframeId);
      if (oldIframe) {
        oldIframe.remove();
      }

      const iframe = document.createElement("iframe");
      iframe.id = iframeId;

      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "0";
      iframe.style.opacity = "0";

      document.body.appendChild(iframe);

      const iframeDoc = iframe.contentWindow.document;

      iframeDoc.open();
      iframeDoc.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <title>${escapeHtml(title)}</title>

            <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.6/dist/JsBarcode.all.min.js"></script>

            <style>
              * {
                box-sizing: border-box;
              }

              body {
                margin: 0;
                padding: 20px;
                font-family: Arial, Helvetica, sans-serif;
                color: #111827;
                background: #ffffff;
              }

              .barcode-grid {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                gap: 12px;
              }

              .barcode-card {
                border: 1px solid #d1d5db;
                border-radius: 8px;
                padding: 12px 10px;
                min-height: 118px;
                page-break-inside: avoid;
                break-inside: avoid;
                text-align: center;
              }

              .student-name {
                font-size: 13px;
                font-weight: 700;
                margin-bottom: 8px;
                line-height: 1.25;
                min-height: 32px;
                display: flex;
                align-items: center;
                justify-content: center;
              }

              .barcode-svg {
                width: 100%;
                max-width: 230px;
                height: 58px;
              }

              .barcode-code {
                margin-top: 6px;
                font-size: 12px;
                letter-spacing: 1px;
                color: #111827;
              }

              @media print {
                body {
                  padding: 12px;
                }

                .barcode-grid {
                  grid-template-columns: repeat(3, 1fr);
                  gap: 10px;
                }

                .barcode-card {
                  border: 1px solid #000;
                }

                @page {
                  size: A4 portrait;
                  margin: 10mm;
                }
              }
            </style>
          </head>

          <body>
            <div class="barcode-grid">
              ${barcodeItemsHtml}
            </div>

            <script>
              function doPrint() {
                try {
                  document.querySelectorAll(".barcode-svg").forEach(function (svg) {
                    var code = svg.getAttribute("data-code");

                    JsBarcode(svg, code, {
                      format: "CODE128",
                      displayValue: false,
                      height: 52,
                      width: 1.6,
                      margin: 0
                    });
                  });

                  setTimeout(function () {
                    window.focus();
                    window.print();
                  }, 400);
                } catch (err) {
                  document.body.innerHTML =
                    "<div style='font-family: Arial; padding: 20px; color: red;'>Gagal membuat barcode. Pastikan koneksi internet aktif karena library barcode dimuat dari CDN.</div>";
                }
              }

              window.onload = function () {
                setTimeout(doPrint, 300);
              };

              window.onafterprint = function () {
                setTimeout(function () {
                  if (window.frameElement && window.frameElement.parentNode) {
                    window.frameElement.parentNode.removeChild(window.frameElement);
                  }
                }, 300);
              };
            </script>
          </body>
        </html>
      `);
      iframeDoc.close();
    };

    const handlePrintSingleBarcode = (row) => {
      handlePrintBarcode([row], "Cetak Barcode Absensi");
    };

    const handlePrintAllBarcode = () => {
      handlePrintBarcode(displayedData, "Cetak Semua Barcode Absensi");
    };

    return (
      <div className="ka-page">
        <style>{css}</style>

        <input
          ref={tapInputRef}
          className="ka-hidden-reader"
          type="text"
          autoComplete="off"
          aria-hidden="true"
          tabIndex={-1}
          onChange={handleTapInputChange}
        />

        <section className="ka-filter-card">
          {/* <div className="ka-filter-header">
            <div className="ka-filter-title-wrap">
              <span className="ka-filter-icon">
                <FilterIcon />
              </span>
              <div>
                <h3 className="ka-filter-title">Filter Data Siswa</h3>
                <p className="ka-filter-subtitle">
                  Pilih semester, cabang, sekolah, tingkatan, dan kelas.
                </p>
              </div>
            </div>
          </div> */}

          {loadingBranch || loadingSemester ? (
            <div className="ka-filter-grid">
              {Array.from({ length: 5 }).map((_, index) => (
                <div className="ka-field" key={`filter-shimmer-${index}`}>
                  <div className="ka-shimmer ka-shimmer-label" />
                  <div className="ka-shimmer ka-shimmer-control" />
                </div>
              ))}

              <div className="ka-field ka-filter-button-field">
                <div className="ka-shimmer ka-shimmer-button" />
              </div>
            </div>
          ) : (
            <>
              <div className="ka-filter-grid">
                <div className="ka-field">
                  <label className="ka-label" htmlFor="filter-semester">
                    Semester
                  </label>
                  <div className="ka-select-wrap">
                    <select
                      id="filter-semester"
                      className="ka-select"
                      name="ysb_semester_id"
                      value={form2.ysb_semester_id}
                      onChange={handleChange}
                    >
                      <option value="" hidden>
                        {namaTA && namaSmstr
                          ? `${namaTA} (Semester ${namaSmstr})`
                          : "Pilih Semester"}
                      </option>
                      {getDataSemesterMap.map((item) => (
                        <option key={item?.id} value={item?.id}>
                          {item?.name_year} (Semester {item?.semester})
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="ka-field">
                  <label className="ka-label" htmlFor="filter-branch">
                    Cabang
                  </label>
                  <div className="ka-select-wrap">
                    <select
                      id="filter-branch"
                      className="ka-select"
                      name="ysb_branch_id"
                      value={form2.ysb_branch_id}
                      onChange={handleChange}
                    >
                      <option value="" hidden>
                        Pilih Cabang
                      </option>
                      {getDataBranch.map((item) => (
                        <option key={item?.branch_code} value={item?.branch_code}>
                          {item?.branch_name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="ka-field">
                  <label className="ka-label" htmlFor="filter-school">
                    Sekolah
                  </label>
                  <div className="ka-select-wrap">
                    <select
                      id="filter-school"
                      className="ka-select"
                      name="ysb_school_id"
                      value={form2.ysb_school_id}
                      onChange={handleChange}
                      disabled={loadingSchool || !form2.ysb_branch_id}
                    >
                      <option value="" hidden>
                        {loadingSchool ? "Memuat data sekolah..." : "Pilih Sekolah"}
                      </option>
                      {!loadingSchool &&
                        getDataSchool.map((item) => (
                          <option key={item?.school_code} value={item?.school_code}>
                            {item?.school_name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="ka-field">
                  <label className="ka-label" htmlFor="filter-level">
                    Tingkatan
                  </label>
                  <div className="ka-select-wrap">
                    <select
                      id="filter-level"
                      className="ka-select"
                      name="ysb_grade_level_id"
                      value={form2.ysb_grade_level_id}
                      onChange={handleChange}
                      disabled={loadingLevel || !form2.ysb_school_id}
                    >
                      <option value="" hidden>
                        {loadingLevel ? "Memuat data tingkatan..." : "Pilih Tingkatan"}
                      </option>
                      {!loadingLevel &&
                        getDataLevel.map((item) => (
                          <option key={item?.id} value={item?.id}>
                            {item?.name_level}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="ka-field">
                  <label className="ka-label" htmlFor="filter-class">
                    Kelas
                  </label>
                  <div className="ka-select-wrap">
                    <select
                      id="filter-class"
                      className="ka-select"
                      name="ysb_kelas_id"
                      value={form2.ysb_kelas_id}
                      onChange={handleChange}
                      disabled={loadingKelas || !form2.ysb_grade_level_id}
                    >
                      <option value="" hidden>
                        {loadingKelas ? "Memuat data kelas..." : "Pilih Kelas"}
                      </option>
                      {!loadingKelas &&
                        getDataKelas.map((item) => (
                          <option key={item?.id} value={item?.id}>
                            {item?.name_kelas}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                <div className="ka-field ka-filter-button-field">
                  <button
                    type="button"
                    className="ka-btn ka-btn-filter"
                    onClick={handleCari}
                    disabled={!isFilterComplete || isFetching}
                  >
                    {isFetching ? (
                      <>
                        <span className="ka-btn-spinner" />
                        Mencari...
                      </>
                    ) : (
                      <>
                        {/* <SearchIcon />
                        Cari Data */}
                        Tampilkan Data
                      </>
                    )}
                  </button>
                </div>
              </div>
            </>
          )}
        </section>

        {isFetching && (
          <div className="ka-loading-card" aria-label="Memuat data siswa">
            <div className="ka-loading-head" />
            <div className="ka-table-scroll">
              {Array.from({ length: 6 }).map((_, index) => (
                <div className="ka-loading-row" key={`table-shimmer-${index}`}>
                  <div className="ka-shimmer ka-loading-line short" />
                  <div className="ka-shimmer ka-loading-line medium" />
                  <div className="ka-shimmer ka-loading-line code" />
                  <div className="ka-shimmer ka-loading-line action" />
                </div>
              ))}
            </div>
          </div>
        )}

        {hasSearched && !isFetching && (
          <>
            <div className="ka-toolbar">
              <div className="ka-search-wrap">
                <span className="ka-search-icon">
                  <SearchIcon />
                </span>
                <input
                  className="ka-search-input"
                  type="search"
                  placeholder="Cari nama siswa atau NISN..."
                  value={searchKeyword}
                  onChange={(event) => setSearchKeyword(event.target.value)}
                />
              </div>

              <div className="ka-toolbar-right">
                <span className="ka-total-badge">
                  Total {displayedData.length} siswa
                </span>
                <button
                  type="button"
                  className="ka-btn ka-btn-primary"
                  onClick={handlePrintAllBarcode}
                  disabled={displayedData.length === 0}
                >
                  <PrintIcon />
                  Cetak Semua
                </button>
              </div>
            </div>

            <div className="ka-reader-note">
              <span className="ka-reader-dot" />
              <span>
                Tap kartu akan otomatis mengisi siswa pada baris yang disorot. Kode juga dapat
                diketik manual, lalu tekan Enter atau klik di luar input untuk menyimpan.
              </span>
            </div>

            <div className="ka-table-card">
              <div className="ka-table-scroll">
                <table className="ka-table">
                  <thead>
                    <tr>
                      <th className="ka-col-no">No</th>
                      <th className="ka-col-name">Nama Siswa</th>
                      <th className="ka-col-code">Kode Absensi</th>
                      <th className="ka-col-action">Aksi</th>
                    </tr>
                  </thead>

                  <tbody>
                    {displayedData.length === 0 ? (
                      <tr>
                        <td colSpan={4} className="ka-empty">
                          <span className="ka-empty-icon">
                            <EmptyIcon />
                          </span>
                          <p className="ka-empty-title">Data siswa tidak ditemukan</p>
                          <p className="ka-empty-text">
                            Coba ubah kata pencarian atau pilih filter yang berbeda.
                          </p>
                        </td>
                      </tr>
                    ) : (
                      displayedData.map((row, index) => {
                        const studentId = row?.ysb_student_id || row?.id;
                        const currentCode = safeStr(
                          kodeAbsenMap[studentId] || row?.kode_absen
                        ).trim();
                        const isSaving = !!savingRows[studentId];

                        return (
                          <tr
                            key={studentId || index}
                            ref={(element) => {
                              if (studentId) {
                                rowTrRefs.current[studentId] = element;
                              }
                            }}
                            className={activeRowIndex === index ? "ka-active-row" : ""}
                          >
                            <td className="ka-col-no">
                              <span className="ka-number-badge">{index + 1}</span>
                            </td>
                            <td className="ka-col-name">
                              <span className="ka-student-name">
                                {toTitleCase(row?.nama_lengkap) || "-"}
                              </span>
                            </td>
                            <td className="ka-col-code">
                              <div className="ka-code-wrap">
                                <input
                                  ref={(element) => {
                                    if (studentId) {
                                      rowInputRefs.current[studentId] = element;
                                    }
                                  }}
                                  className={`ka-code-input ${
                                    activeRowIndex === index ? "is-active" : ""
                                  }`}
                                  type="text"
                                  inputMode="numeric"
                                  autoComplete="off"
                                  maxLength={20}
                                  value={kodeAbsenMap[studentId] || ""}
                                  onFocus={() => handleManualKodeFocus(index)}
                                  onChange={(event) =>
                                    handleManualKodeChange(studentId, event.target.value)
                                  }
                                  onBlur={() => handleManualKodeBlur(studentId, index)}
                                  onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                      event.preventDefault();
                                      event.currentTarget.blur();
                                    }
                                  }}
                                  disabled={isSaving}
                                  aria-label={`Kode absensi ${toTitleCase(row?.nama_lengkap)}`}
                                />

                                {isSaving && (
                                  <div className="ka-saving-overlay">
                                    <span className="ka-saving-dot" />
                                    Menyimpan...
                                  </div>
                                )}
                              </div>
                            </td>
                            <td className="ka-col-action">
                              <button
                                type="button"
                                className="ka-btn ka-btn-action"
                                onClick={() => handlePrintSingleBarcode(row)}
                                disabled={!currentCode || isSaving}
                              >
                                <PrintIcon />
                                Cetak
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </div>
    );
}
